import { CircleIcCheck, CircleTimes, Clock } from 'components/Icons';
import { formatData, formatHora } from 'helpers/utils/HTMLUtils';
import { toRequest } from 'helpers/utils/RequestUtils';
import { getAssembleiasAssessorEndpoint } from 'library/Apis';
import moment from 'moment';
import {
  ButtonThemes,
  Col,
  DatePicker,
  IconButton,
  Input,
  Modal,
  Row,
  ToastTypes,
} from 'plataforma-fundacao-componentes';
import { ModalProps } from 'plataforma-fundacao-componentes/dist/components/modal/Modal';
import { useCallback, useContext, useEffect, useState } from 'react';
import ApiService from 'services/ApiService';
import {
  EditarEventoModalValidator,
  ValidatorProps,
} from './EditarEventoModalValidator';

import LayoutContext from 'components/Layout/LayoutContext';
import translation from 'locales/translation';
import './styles.scss';
const rootClassName = 'component-editar-evento-modal';

interface EditarEventoModalProps extends ModalProps {
  assembleiaId: number | string;
  assembleiaTitle?: string;
  assembleiaDescription?: string;
  assembleiaDate?: string;
  assembleiaDateEnd?: string;
  assembleiaHour?: string;
  assembleiaHourEnd?: string;
  onConfirm: () => Promise<void>;
}

const momentDate = (date: string) => moment(date).format('DD/MM/yyyy');
const momentHour = (hour: string) => moment(hour).format('HH:mm');

const infoAssemblyPrefix = translation.Assessor.Modal.InfoAssembly;

export const EditarEventoModal = (props: EditarEventoModalProps) => {
  const [loading, setLoading] = useState(false);

  const [titulo, setTitulo] = useState<any>(props?.assembleiaTitle!);
  const [descricao, setDescricao] = useState<any>(
    props?.assembleiaDescription!
  );
  const [dataInicio, setDateInicio] = useState<any>(
    momentDate(props?.assembleiaDate!)
  );
  const [dataFim, setDataFim] = useState<any>(
    momentDate(props?.assembleiaDateEnd!)
  );
  const [horaInicio, setHoraInicio] = useState<any>(
    momentHour(props?.assembleiaHour!)
  );
  const [horaFim, setHoraFim] = useState<any>(
    momentHour(props?.assembleiaHourEnd!)
  );

  const [sent, setSent] = useState(false);
  const [validator, setValidator] = useState<ValidatorProps>();

  const { showToast } = useContext(LayoutContext);

  const handleClose = () => {
    props.onClose?.(props.modalKey);
  };

  useEffect(() => {
    setValidator(
      EditarEventoModalValidator(
        titulo,
        dataInicio,
        dataFim,
        horaInicio,
        horaFim
      )
    );
  }, [sent, titulo, dataInicio, horaInicio, dataFim, horaFim]);

  const initialValues = useCallback(() => {
    if (
      props.assembleiaTitle === titulo &&
      props.assembleiaDescription === descricao &&
      momentDate(props?.assembleiaDate!) === dataInicio &&
      momentDate(props?.assembleiaDateEnd!) === dataFim &&
      momentHour(props?.assembleiaHour!) === horaInicio &&
      momentHour(props?.assembleiaHourEnd!) === horaFim
    ) {
      return true;
    }

    return false;
  }, [dataFim, dataInicio, descricao, horaFim, horaInicio, props, titulo]);

  return (
    <Modal
      preventEscExit={props.preventEscExit || false}
      preventMaskExit={props.preventMaskExit || false}
      modalKey={props.modalKey}
      mobileOn={props.mobileOn}
      title={props.title}
      footer={[
        {
          theme: ButtonThemes.Secondary,
          leftIcon: <CircleTimes />,
          children: infoAssemblyPrefix.buttons.cancelButtonLabel,
          'aria-label': infoAssemblyPrefix.buttons.cancelButtonLabel,
          onClick: handleClose,
        },
        {
          loading: loading,
          theme: ButtonThemes.Primary,
          leftIcon: <CircleIcCheck />,
          children: infoAssemblyPrefix.buttons.confirmButtonLabel,
          'aria-label': infoAssemblyPrefix.buttons.confirmButtonLabel,
          disabled:
            initialValues() || (sent && validator && !validator.allIsValid()),
          onClick: () => {
            return new Promise<any>(
              (resolve: (evt?: any) => void, reject: () => void) => {
                if (!sent) setSent(true);
                if (!validator || !validator.allIsValid()) return;
                if (typeof props.onConfirm === 'function') {
                  setLoading(true);

                  const url = `${getAssembleiasAssessorEndpoint(
                    '1'
                  )}evento/offline`;
                  const dataEvento = `${moment(dataInicio, 'DD/MM/yyyy').format(
                    'yyyy-MM-DD'
                  )}T${horaInicio}:00`;
                  const dataFimEvento = `${moment(dataFim, 'DD/MM/yyyy').format(
                    'yyyy-MM-DD'
                  )}T${horaFim}:00`;

                  const data = {
                    id: props.assembleiaId,
                    title: titulo,
                    description: descricao,
                    startDate: dataEvento,
                    endDate: dataFimEvento,
                  };

                  toRequest(ApiService.put, [url, data], 'editEventOffline')
                    .then(() => {
                      props
                        .onConfirm()
                        .then(() => {
                          setSent(false);
                          setLoading(false);
                          resolve();
                        })
                        .catch(() => {
                          reject();
                          setLoading(false);
                        });
                    })
                    .catch((error) => {
                      // const formatDate = (date: Date): string => {
                      //   const day = date.getDate().toString().padStart(2, '0');
                      //   const month = (date.getMonth() + 1)
                      //     .toString()
                      //     .padStart(2, '0');
                      //   const year = date.getFullYear();
                      //   return `${day}/${month}/${year}`;
                      // };

                      // const getPermittedDateRange = (): {
                      //   startDate: Date;
                      // } => {
                      //   const today = new Date();
                      //   const dayOfMonth = today.getDate();
                      //   const startDate = new Date();

                      //   if (dayOfMonth >= 1 && dayOfMonth <= 15) {
                      //     startDate.setMonth(startDate.getMonth() - 1);
                      //     startDate.setDate(1);
                      //   } else {
                      //     startDate.setDate(1);
                      //   }

                      //   return { startDate };
                      // };

                      // const { startDate } = getPermittedDateRange();

                      setLoading(false);
                      showToast({
                        pauseOnFocusLoss: true,
                        theme: ToastTypes.Error,
                        showStatusBar: true,
                        timeout: 4000,
                        label:
                          translation.Toasts.Errors.Keys[
                            `${
                              error.response?.data.message ||
                              error.response?.data ||
                              error.message
                            }` as keyof typeof translation.Toasts.Errors.Keys
                          ] ?? translation.Toasts.Errors.defaultAlternative,
                      });
                    });
                }
              }
            );
          },
        },
      ]}
      className={rootClassName}
      onClose={props.onClose}
    >
      <Row>
        <Col cols={[12, 12, 12, 12, 12]}>
          <Input
            id={'input-assembleia-title'}
            data-testid={'input-assembleia-title'}
            value={titulo}
            onChange={(evt) => {
              setTitulo(evt.target.value);
            }}
            label={infoAssemblyPrefix.tituloAssembleia}
            placeholder={infoAssemblyPrefix.tituloPlaceholder}
            counter
            maxLength={200}
            error={sent && validator && validator.tituloIsValid().error}
            helperText={
              sent && validator ? validator.tituloIsValid().helperText : ''
            }
          />
        </Col>
        <Col cols={[12, 12, 12, 12, 12]}>
          <Input
            data-testid={'input-assembleia-description'}
            value={descricao}
            onChange={(evt) => {
              setDescricao(evt.target.value);
            }}
            label={infoAssemblyPrefix.descricaoAssembleia}
            placeholder={infoAssemblyPrefix.descricaoPlaceholder}
          />
        </Col>
      </Row>
      <Row>
        <Col cols={[12, 12, 12, 12, 12]}>Horário do evento</Col>
      </Row>
      <Row>
        <Col cols={[12, 6, 6, 6, 6]}>
          <Input
            id={'input-assembleia-data-evento'}
            data-testid={'input-assembleia-data-evento'}
            value={dataInicio}
            onChange={(evt) => {
              setDateInicio(formatData(evt.target.value));
            }}
            rightObject={
              <DatePicker
                onChange={(date) => {
                  setDateInicio(date);
                }}
                queryToAppend={'#input-assembleia-data-evento'}
                initialValue={dataInicio}
                closeOnChange
              />
            }
            label={infoAssemblyPrefix.dataEventoAssembleia}
            placeholder={infoAssemblyPrefix.dataEventoAssembleiaPlaceholder}
            error={sent && validator && validator.dataInicioIsValid().error}
            helperText={
              sent && validator ? validator.dataInicioIsValid().helperText : ''
            }
          />
        </Col>
        <Col cols={[12, 6, 6, 6, 6]}>
          <Input
            id={'input-assembleia-horario-evento'}
            data-testid={'input-assembleia-horario-evento'}
            label={infoAssemblyPrefix.horaEventoAssembleia}
            placeholder={infoAssemblyPrefix.horaEventoAssembleiaPlaceholder}
            value={horaInicio}
            onChange={(evt) => setHoraInicio(formatHora(evt.target.value))}
            inputMode={'numeric'}
            maxLength={5}
            rightObject={<IconButton icon={<Clock />} />}
            error={sent && validator && validator.horaInicioIsValid().error}
            helperText={
              sent && validator ? validator.horaInicioIsValid().helperText : ''
            }
          />
        </Col>
      </Row>
      <Row>
        <Col cols={[12, 6, 6, 6, 6]}>
          <Input
            id={'input-assembleia-data-encerramento-evento'}
            data-testid={'input-assembleia-data-encerramento-evento'}
            value={dataFim}
            onChange={(evt) => {
              setDataFim(formatData(evt.target.value));
            }}
            rightObject={
              <DatePicker
                onChange={(date) => setDataFim(date)}
                queryToAppend={'#input-assembleia-data-encerramento-evento'}
                initialValue={dataFim}
                closeOnChange
              />
            }
            label={infoAssemblyPrefix.dataEncerramentoEventoAssembleia}
            placeholder={
              infoAssemblyPrefix.dataEncerramentoEventoAssembleiaPlaceholder
            }
            error={sent && validator && validator.dataFimIsValid().error}
            helperText={
              sent && validator ? validator.dataFimIsValid().helperText : ''
            }
          />
        </Col>
        <Col cols={[12, 6, 6, 6, 6]}>
          <Input
            id={'input-assembleia-horario-encerramento-evento'}
            data-testid={'input-assembleia-horario-encerramento-evento'}
            label={infoAssemblyPrefix.horaEncerramentoEventoAssembleia}
            placeholder={
              infoAssemblyPrefix.horaEncerramentoEventoAssembleiaPlaceholder
            }
            value={horaFim}
            onChange={(evt) => setHoraFim(formatHora(evt.target.value))}
            inputMode={'numeric'}
            maxLength={5}
            rightObject={<IconButton icon={<Clock />} />}
            error={sent && validator && validator.horaFimIsValid().error}
            helperText={
              sent && validator ? validator.horaFimIsValid().helperText : ''
            }
          />
        </Col>
      </Row>
    </Modal>
  );
};
